import { render, staticRenderFns } from "./detallesMantenimientos.vue?vue&type=template&id=044f9ec5&scoped=true"
import script from "./detallesMantenimientos.vue?vue&type=script&lang=js"
export * from "./detallesMantenimientos.vue?vue&type=script&lang=js"
import style0 from "./detallesMantenimientos.vue?vue&type=style&index=0&id=044f9ec5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044f9ec5",
  null
  
)

export default component.exports